class APIError extends Error {
  constructor(message, code, data) {
    super(message); // Call the parent constructor with the message
    this.name = this.constructor.name; // Set the error name to the class name
    this.code = code; // Add the custom code property
    this.data = data;
  }
}

export default APIError;